import words from './data/words.json';

/**
 * Everyday Dutch words of two to six letters, most frequent first — what the
 * word phase plays once a lesson's letters are known. Generated by
 * `web/scripts/build-morse-words.mjs` from the official Woordenlijst, ordered by
 * an OpenSubtitles frequency list; committed, so a lesson needs no network.
 */
export const MORSE_WORDS = words as string[];
